<template>
    <div class="contrast-list-content">
        <div v-show="!gotData" class="layout-rl-note">正在加载数据...</div>
        <no-data
            v-show="gotData && !listData.length"
            v-bind:noteText="'还没有对比记录~'"
            v-bind:showButton="true"
            v-bind:buttonText="'马上去创建对比'"
            v-bind:buttonFunc="clickStartContrast">
        </no-data>
        <virtual-list
            ref="vsl"
            v-show="gotData && !!listData.length"
            id="ContrastVirtualList"
            class="overflow-y-scroll scroll-touch"
            :data-key="'id'"
            :data-sources="listData"
            :data-component="itemComponent"

            :estimate-size="50"
            :footer-class="'contrast-list-note'"
            v-on:tobottom="onScrollToBottom">
        </virtual-list>
    </div>
</template>

<script>
import NoData from '../../components/common/NoData.vue'
import ContrastListItem from '../../components/contrast/ContrastListItem.vue'
export default {
    name: 'ContrastVirtualList',
    components: { NoData },
    props: {
        listData: {
            type: Array,
            default() { return [] }
        },
        gotData: {
            type: Boolean,
            default() { return false }
        },
        hideLoading: {
            type: Boolean,
            default() { return false }
        },
        startContrastFunc: {
            type: Function,
            default() { return null }
        }
    },
    computed: {
        
    },
    data() {
        return {
            itemComponent: ContrastListItem,
        }
    },
    mounted() {
        // this.$bus.on('scrollFamousToTop', this.scrollToTop)
    },
    destroyed() {
        // this.$bus.off('scrollFamousToTop', this.scrollToTop)
    },
    methods: {
        clickStartContrast() {
            if(this.startContrastFunc && typeof(this.startContrastFunc) == 'function') {
                this.startContrastFunc();
            }
        },
        onScrollToBottom() {

        }
    }
}
</script>